export const formStepTexts = [
  {
    title: 'Registrate con tu mail',
    secondTitle: 'Empezá tu prueba gratuita',
    buttonText: 'Probar Calu gratis',
    fields: {
      email: { name: 'email', labelText: 'Email' },
      password: { name: 'password', labelText: 'Contraseña', helperText: 'Debe contener al menos 8 caracteres' },
      repeatPassword: { name: 'repeatPassword', labelText: 'Verifique su contraseña' },
    },
  },
  {
    title: 'Contános un poco más sobre vos',
    subtitle: 'Con esta información podremos crear una agenda que se ajuste a tus necesidades',
    buttonText: 'Comenzar mi prueba gratuita',
    fields: {
      firstname: { name: 'firstname', labelText: 'Nombre' },
      lastname: { name: 'lastname', labelText: 'Apellido' },
      mobile: { name: 'mobile', labelText: 'Celular' },
      category: { name: 'category', labelText: 'Profesión o rubro' },
      centreName: { name: 'centreName', labelText: 'Nombre del centro' },
      botTrap: { name: 'botTrap', labelText: 'Info', helperText: 'Info' },
    },
  },
]
